import { createRouter, createWebHistory } from 'vue-router'
import { usarSesion } from '@/stores/guion'
import { token } from '@/api/cliente'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/entrar', name: 'entrar', component: () => import('@/views/Entrar.vue'), meta: { publica: true } },
    { path: '/', name: 'tenants', component: () => import('@/views/Tenants.vue') },
    { path: '/plataforma', name: 'plataforma', component: () => import('@/views/Plataforma.vue') },

    // Lo COMPARTIDO. Va al primer nivel y no dentro de un cliente a proposito:
    // publicar aqui mueve lo que heredaran varios, y meterlo bajo /tenants/:id
    // haria pensar que el cambio es de ese cliente.
    { path: '/catalogo', name: 'catalogo', component: () => import('@/views/Catalogo.vue') },
    { path: '/capas', name: 'capas', component: () => import('@/views/Capas.vue') },
    { path: '/usuarios', name: 'usuarios', component: () => import('@/views/Usuarios.vue') },

    // La factura de IA de TODOS los clientes. Va al primer nivel por lo mismo
    // que el catalogo: cuelga de la plataforma, no de un cliente. Dentro de uno
    // haria pensar que ese es el que se esta facturando.
    { path: '/facturacion', name: 'facturacion', component: () => import('@/views/Facturacion.vue') },
    {
      path: '/tenants/:id',
      component: () => import('@/views/Guion.vue'),
      props: true,
      children: [
        { path: '', name: 'pasos', component: () => import('@/views/Pasos.vue'), props: true },
        { path: 'grafo', name: 'grafo', component: () => import('@/views/Grafo.vue'), props: true },
        { path: 'plantillas', name: 'plantillas', component: () => import('@/views/Plantillas.vue'), props: true },
        { path: 'composicion', name: 'composicion', component: () => import('@/views/Composicion.vue'), props: true },
        { path: 'versiones', name: 'versiones', component: () => import('@/views/Versiones.vue'), props: true },
        { path: 'operacion', name: 'operacion', component: () => import('@/views/Operacion.vue'), props: true },
        { path: 'inteligencia', name: 'inteligencia', component: () => import('@/views/Inteligencia.vue'), props: true },
        { path: 'fallas', name: 'fallas', component: () => import('@/views/Fallas.vue'), props: true },
        { path: 'evaluaciones', name: 'evaluaciones', component: () => import('@/views/Evaluaciones.vue'), props: true },
      ],
    },
  ],
})

// Guardia de sesion. Se recupera del token guardado en vez de exigir entrar en
// cada recarga: quien edita un guion recarga la pagina a menudo.
router.beforeEach(async (a) => {
  if (a.meta.publica) return true

  const sesion = usarSesion()
  if (sesion.autenticado) return true
  if (!token.leer()) return { name: 'entrar', query: { volver: a.fullPath } }

  const ok = await sesion.recuperar()
  return ok ? true : { name: 'entrar', query: { volver: a.fullPath } }
})
